import type { VoteOnPoll200OptionsItem } from './voteOnPoll200OptionsItem';

export type VoteOnPoll200 = {
  isExpired?: boolean;
  options?: VoteOnPoll200OptionsItem[];
  pollId?: string;
  success?: boolean;
  totalVotes?: number;
  userVoted?: boolean;
  userVotedOptionId?: string;
};
